let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("88rz2")).then(() => parcelRequire('78NH5'));